import { queryOptions } from '@tanstack/react-query';

import { shortCacheOptions } from '@platform/core/state';

import { getRendallApiClient } from '../rendall-api-client';

const getUserInfoQueryKey = () => ['rendall', 'user-info'];

/** @deprecated This endpoint will be removed */
export const userInfoQuery = () =>
  queryOptions({
    queryFn: () => {
      const client = getRendallApiClient();
      return client.getUserInfo();
    },
    queryKey: getUserInfoQueryKey(),
    ...shortCacheOptions,
  });
